import React, { useState, useEffect } from 'react';
import { Zap, X, Menu } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast, ToastContainer } from 'react-toastify';
import {jwtDecode} from 'jwt-decode';
import OtpModal from './modal';


const api=process.env.REACT_APP_API_URL;

export const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [userDetails, setUserDetails] = useState(null); // Start with null, not false
    const navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [isDropdownOpen, setDropdownOpen] = useState(false)

    useEffect(() => {
      const fetchUserDetails = async () => {
          const storedUser = JSON.parse(localStorage.getItem('userdetails'));
          const accessToken = Cookies.get('access_token');

          if (!storedUser || !accessToken) return;

          try {
              const decodedToken = jwtDecode(accessToken);
              const currentTime = Math.floor(Date.now() / 1000);

              if (decodedToken.exp < currentTime) {
                  // Token expired, attempt refresh using httponly refresh cookie
                  // (browser sends it automatically via credentials: 'include')
                  const response = await fetch(`${api}auth/refresh/`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      credentials: 'include',
                  });

                  if (response.ok) {
                      const data = await response.json();
                      Cookies.set('access_token', data.access, { expires: 10 });
                      setUserDetails(storedUser);
                  } else {
                      doLogout();
                  }
              } else {
                  setUserDetails(storedUser);
              }
          } catch (error) {
              // Malformed token, clear and stay logged out silently
              Cookies.remove('access_token');
              localStorage.removeItem('userdetails');
          }
      };

      fetchUserDetails();
  // Intentionally runs once on mount; doLogout is recreated per render and
  // must not retrigger this effect.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const doLogout = () => {
    Cookies.remove('access_token');
    Cookies.remove('access');
    Cookies.remove('refresh');
    localStorage.clear();
    setUserDetails(null);
    navigate('/');
  };

  const handleLogout = async () => {
    try {
      await fetch(`${api}auth/logout/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
    } catch (_) {}
    toast.success("Logged out successfully.");
    doLogout();
  };
  


    
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    
      const handleOtpModalClose = () => {
        setModalOpen(false); // Close the modal
      };

    return (
      <>
            <ToastContainer />
        <div
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                isScrolled
                    ? 'shadow-lg border-b-2 bg-white border-transparent'
                    : isMenuOpen
                    ? 'bg-sky-300'
                    : 'bg-sky-300/30 sm:bg-sky-300/30'
            }`}
        >
            <nav className="container mx-auto px-4 sm:px-8 py-4 sm:py-6">
                <div className="flex flex-wrap sm:flex-nowrap justify-between items-center max-w-7xl mx-auto">
                    <div className="flex items-center">
                        <Link to={`${userDetails ? "/home" : "/"}`} className="flex flex-row items-center space-x-2">
                            <Zap className="w-8 h-8 text-orange-500" />
                            <span className="text-xl md:text-3xl font-bold text-gray-900">
                                Resume Advisor
                            </span>
                        </Link>
                    </div>

                    <button
                        className="sm:hidden text-black focus:outline-none"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>

                    <div
                        className={`w-full sm:w-auto ${
                            isMenuOpen ? 'block' : 'hidden sm:bg-transparent'
                        } sm:block mt-4 sm:mt-0`}
                    >
                        <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:space-x-4 md:space-x-8 sm:space-y-0">
                            {['Features', 'Pricing', 'Auto-Apply'].map((item) => (
                                <Link
                                    key={item}
                                    to={`/${item.toLowerCase()}`}
                                    className="text-black cursor-pointer hover:text-gray-900 transition-colors sm:py-0 relative group"
                                >
                                    {item}
                                    <span className="absolute left-0 bottom-0 right-0 h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
                                </Link>
                            ))}

                            {userDetails ? (
                                <div className="relative">
                                {/* User Avatar and Dropdown Trigger */}
                                <div
                                  className="flex items-center cursor-pointer"
                                  onClick={() => setDropdownOpen(!isDropdownOpen)}
                                >
                                  <div
                                    className="w-8 h-8 bg-gray-500 text-white rounded-full flex items-center justify-center uppercase"
                                    title={userDetails?.name}
                                  >
                                    {userDetails?.name?.[0]}
                                  </div>
                                  <span className="ml-2 text-gray-800">{userDetails?.name}</span>
                                </div>
                          
                                {/* Dropdown Menu */}
                                {isDropdownOpen && (
                                  <div className="absolute top-full right-0 mt-2 w-[80vw] sm:w-[60vw] md:w-[40vw] lg:w-[20vw] bg-white border rounded-lg shadow-lg z-50">
                                    <div className="px-4 py-3 border-b text-sm text-gray-900">
                                      <p className="font-semibold">{userDetails?.name}</p>
                                      <div className="flex items-center space-x-2">
                                        <p className="text-gray-500">{userDetails?.email}</p>
                                        {/* {userDetails?.isVerified ? (
                                          <img
                                            src="https://res.cloudinary.com/danm2mfq5/image/upload/v1735663120/l6jcbeso44knlhcd7fes.png"
                                            alt="Verified"
                                            title="Verified"
                                            className="w-5 h-5 text-blue-600"
                                          />
                                        ) : (
                                          <img
                                            src="https://res.cloudinary.com/danm2mfq5/image/upload/v1735663167/laoik9dxfm6wydotdkui.png"
                                            alt="Not Verified"
                                            title="Not Verified"
                                            className="w-5 h-5 text-red-600 cursor-pointer"
                                            onClick={handleOtpModalOpen}
                                          />
                                        )} */}
                                      </div>
                                    </div>
                                    
                                    <div
                                      className="px-4 py-3 flex items-center text-[16px] text-red-600 cursor-pointer hover:bg-gray-100 rounded-lg"
                                      onClick={handleLogout}
                                    >
                                      Logout
                                    </div>
                                  </div>
                                )}
                          
                                {/* Render the OtpModal when isModalOpen is true */}
                                {isModalOpen && (
                                  <OtpModal
                                    email={userDetails?.email}
                                    onClose={handleOtpModalClose}
                                  />
                                )}
                              </div>
                            ) : (
                                <>
                                    <Link
            to="/signin"
            className="text-black cursor-pointer hover:text-gray-900 transition-colors relative group"
        >
            Sign In
            <span className="absolute left-0 bottom-0 right-0 h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
        </Link>
                                    <Link
                                        to="/signup"
                                        className="bg-blue-600 cursor-pointer hover:bg-orange-500 text-white px-4 py-2 rounded-lg text-center"
                                    >
                                        Sign Up
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
        </>
    );
};
